import { Banner } from "@app/ui/shared/banner";

export const DiskRestartWarning = ({ className }: { className?: string }) => (
  <Banner variant="info" className={className}>
    This action will restart the service.
  </Banner>
);
